import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 26, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, step = 0.14, onMount = false }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className={`block overflow-hidden ${lineClass}`}>
        <motion.span
          className="block will-change-transform"
          initial={{ y: "112%" }}
          {...(onMount
            ? { animate: { y: "0%" } }
            : { whileInView: { y: "0%" }, viewport: { once: true, amount: 0.4 } })}
          transition={{ duration: 1.05, delay: delay + i * step, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p
    className={`flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.34em] text-gold ${className}`}
  >
    <span className="inline-block h-px w-8 bg-gold/60" aria-hidden="true" />
    {children}
  </p>
);

export const SectionHead = ({ index, title, lead, className = "" }) => (
  <Reveal className={`max-w-3xl ${className}`}>
    <Eyebrow>{index}</Eyebrow>
    <h2 className="mt-6 font-display text-3xl leading-[1.12] tracking-[-0.01em] text-ivory md:text-5xl">
      {title}
    </h2>
    {lead && <p className="mt-6 max-w-2xl text-[17px] leading-relaxed text-mist">{lead}</p>}
  </Reveal>
);
